module.exports = __webpack_public_path__ + "img/pc__main_logo_g.0609ed90.png";